/*
 * Size guide — product page
 * Pairs with snippets/size-guide.liquid and assets/size-guide.css
 *
 * Events (bubble from the [data-size-guide] element):
 *   size-guide:select  detail { size, variant }        — shopper picked a size from the guide
 *   size-guide:added   detail { item, properties }     — custom size added to cart
 *
 * Open from anywhere:  <button data-size-guide-open="custom">…</button>  (tab is optional)
 */
(function () {
  'use strict';

  function qs(root, sel) { return root.querySelector(sel); }
  function qsa(root, sel) { return Array.prototype.slice.call(root.querySelectorAll(sel)); }
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function toIn(v, unit) { return unit === 'cm' ? v / 2.54 : v; }
  function fromIn(v, unit) { return unit === 'cm' ? Math.round(v * 2.54) : Math.round(v * 4) / 4; }
  function mid(v) { return Array.isArray(v) ? (v[0] + v[1]) / 2 : v; }
  function fmt(v, from, to) {
    if (Array.isArray(v)) return fmt(v[0], from, to) + '–' + fmt(v[1], from, to);
    if (typeof v !== 'number') return String(v);
    if (from === to) return String(v);
    return String(fromIn(toIn(v, from), to));
  }
  function orList(list) {
    if (list.length < 2) return list.join('');
    return list.slice(0, -1).join(', ') + ' or ' + list[list.length - 1];
  }

  /* ---------- measurement catalogue ----------
   * Keys usable in the custom_fields and measure_steps config.
   * "bust" shows as "Chest" on men's products.                                   */
  var MEASURES = {
    bust: {
      label: null, // filled from chestLabel
      text: {
        women: 'Measure around the fullest part of your bust, keeping the tape level and under your arms.',
        men: 'Measure around the fullest part of your chest, just under the armpits. Keep the tape level across your back.',
        unisex: 'Measure around the fullest part of your chest, just under the armpits. Keep the tape level across your back.'
      },
      svg: { side: 'r', y: 118, x0: 140, shape: '<ellipse cx="100" cy="118" rx="40" ry="6"/>' }
    },
    waist: {
      label: 'Waist',
      text: {
        women: 'Measure around the narrowest part of your waist, usually just above the belly button.',
        men: 'Measure around your natural waistline, where you normally wear your trousers.',
        unisex: 'Measure around your natural waistline, the narrowest part of your torso.'
      },
      svg: { side: 'r', y: 178, x0: 134, shape: '<ellipse cx="100" cy="178" rx="34" ry="5"/>' }
    },
    hip: {
      label: 'Hip',
      text: 'Stand with feet together and measure around the fullest part of your hips.',
      svg: { side: 'r', y: 226, x0: 142, shape: '<ellipse cx="100" cy="226" rx="42" ry="6"/>' }
    },
    shoulder: {
      label: 'Shoulder',
      text: 'Measure across your back from the tip of one shoulder bone to the other.',
      svg: { side: 'l', y: 90, x0: 54, shape: '<line x1="54" y1="90" x2="146" y2="90"/>' }
    },
    length: {
      label: 'Length',
      text: 'Measure from the highest point of your shoulder, next to the neck, straight down to where you want the garment to end.',
      svg: { side: 'l', y: 262, x0: 74, shape: '<line x1="74" y1="80" x2="74" y2="262"/>' }
    },
    neck_depth: {
      label: 'Neck depth',
      text: 'Measure from the base of your neck at the shoulder line straight down to where you want the front neckline to sit.',
      svg: { side: 'r', y: 84, x0: 104, shape: '<line x1="100" y1="64" x2="100" y2="102"/>' }
    },
    sleeve: {
      label: 'Sleeve length',
      text: 'Measure from the tip of your shoulder down your arm to where you want the sleeve to end.',
      svg: { side: 'l', y: 150, x0: 41, shape: '<line x1="47" y1="98" x2="37" y2="192"/>' }
    },
    inseam: {
      label: 'Inseam',
      text: 'Measure from the top of your inner thigh down to your ankle bone.',
      svg: { side: 'r', y: 330, x0: 100, shape: '<line x1="100" y1="262" x2="100" y2="396"/>' }
    }
  };

  function genderKey(g) { return g === 'men' || g === 'unisex' ? g : 'women'; }

  // "chest" and "bust" are the same measurement (diagram line + instructions)
  function measureInfo(key) {
    if (MEASURES[key]) return MEASURES[key];
    if (key === 'chest') return MEASURES.bust;
    return null;
  }

  // Used when the general chart entry has no custom_fields / measure_steps config
  var DEFAULT_STEPS = {
    women: ['bust', 'waist', 'hip', 'shoulder', 'length', 'neck_depth'],
    men: ['bust', 'waist', 'hip', 'inseam'],
    unisex: ['shoulder', 'chest', 'waist', 'hip']
  };
  var DEFAULT_CUSTOM = {
    women: [{ key: 'bust', required: true }, { key: 'waist', required: true }, { key: 'hip', required: true }, { key: 'shoulder' }],
    men: [{ key: 'bust', required: true }, { key: 'waist', required: true }, { key: 'hip', required: true }, { key: 'shoulder' }],
    unisex: [{ key: 'chest', required: true }, { key: 'waist', required: true }, { key: 'hip', required: true }, { key: 'shoulder' }]
  };

  // Accepts ["bust", "waist"] or [{ "key": "bust", "label": "…", "text": "…", "required": true }]
  function normalise(list) {
    if (!Array.isArray(list)) return null;
    return list.map(function (item) {
      return typeof item === 'string' ? { key: item } : item;
    }).filter(function (item) { return item && item.key; });
  }

  /* ---- bot protection: Google reCAPTCHA (invisible). The custom-size app tells us the key. ---- */
  /* Shared by the size guide, made-to-order and contact scripts: loads Google reCAPTCHA once per page,
     waits until it is really ready, and keeps working even if the theme or Shopify also loads its own reCAPTCHA. */
  var CAPTCHA = window.__dhiCaptchaV2 || (window.__dhiCaptchaV2 = (function () {
    var key = null, ent = null, loading = null;
    function warn(msg, e) { try { console.warn('[DhiEarth forms] ' + msg, e || ''); } catch (x) {} }
    function setup(base) {
      if (!loading) {
        loading = fetch(base + '/config', { credentials: 'same-origin' })
          .then(function (r) { return r.json(); })
          .then(function (c) {
            key = c && c.recaptchaSiteKey;
            if (!key) return null;
            return new Promise(function (resolve) {
              var started = Date.now();
              if (!document.querySelector('script[data-dhi-recaptcha]')) {
                var sc = document.createElement('script');
                sc.src = 'https://www.google.com/recaptcha/enterprise.js?render=' + encodeURIComponent(key);
                sc.async = true;
                sc.setAttribute('data-dhi-recaptcha', '');
                sc.onerror = function () { warn('reCAPTCHA script was blocked (ad blocker or network)'); };
                document.head.appendChild(sc);
              }
              (function poll() {
                var e = window.grecaptcha && window.grecaptcha.enterprise;
                if (e && typeof e.execute === 'function') { ent = e; return resolve(); }
                if (Date.now() - started > 10000) { warn('reCAPTCHA did not load in time'); return resolve(); }
                setTimeout(poll, 100);
              })();
            });
          })
          .catch(function (e) { warn('could not read the app settings', e); loading = null; });
      }
      return loading;
    }
    function token(base, action) {
      return Promise.race([
        Promise.resolve(setup(base)).then(function () {
          if (!key) return '';
          var e = ent || (window.grecaptcha && window.grecaptcha.enterprise);
          if (!e) return '';
          return new Promise(function (resolve) {
            e.ready(function () {
              e.execute(key, { action: action }).then(resolve, function (err) { warn('reCAPTCHA check failed', err); resolve(''); });
            });
          });
        }),
        new Promise(function (resolve) { setTimeout(function () { resolve(''); }, 12000); })
      ]);
    }
    // Send the form; if Google says the token came from a hiccup in the browser (BROWSER_ERROR etc.),
    // quietly get a fresh token and send once more, so the customer never sees it.
    function send(url, payload, base, action) {
      function once(retry) {
        return token(base, action).then(function (t) {
          payload.captcha = t;
          if (retry) payload.captcha_retry = true;
          return fetch(url, {
            method: 'POST', credentials: 'same-origin',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify(payload)
          });
        }).then(function (r) {
          return r.json().catch(function () { return {}; }).then(function (j) { return { ok: r.ok, j: j }; });
        }).then(function (res) {
          if (!retry && res.j && res.j.retry_captcha) { warn('reCAPTCHA hiccup, retrying with a fresh token'); return once(true); }
          return res;
        });
      }
      return once(false);
    }
    return { setup: setup, token: token, send: send };
  })());
  function captchaSetup(base) { return CAPTCHA.setup(base); }
  function captchaToken(base, action) { return CAPTCHA.token(base, action); }

  function SizeGuide(root) {
    this.root = root;
    this.data = JSON.parse(qs(root, '[data-sg-data]').textContent);
    this.dialog = qs(root, 'dialog');
    this.form = this.findProductForm();
    this.unit = 'in';
    this.tab = this.data.startTab || (this.data.product ? 'product' : 'body');
    this.size = null;
    this.base = null;
    // Custom size as a consultation request (default): nothing goes in the cart, nothing is paid now
    this.consult = !!this.data.customValue && this.data.customFlow === 'consultation'; // older snippets without the setting keep the cart flow
    // A sent request only lasts until the page is reloaded: a refresh starts with a fresh custom form
    this.requestRef = null;
    try {
      sessionStorage.removeItem('sg-request-' + this.data.productId);       // left over from older versions
      sessionStorage.removeItem('sg-request-email-' + this.data.productId);
    } catch (e) { /* storage blocked */ }
    var g = genderKey(this.data.gender);
    this.steps = normalise(this.data.measureSteps) || normalise(DEFAULT_STEPS[g]);
    this.customFields = normalise(this.data.customFields) || normalise(DEFAULT_CUSTOM[g]);
    this.buildMeasure();
    this.buildCustomFields();
    this.buildCheckFields();
    this.bind();
    this.initGate();
    this.hideQuantity();
    this.initPicker();
    this.resetCustomForm();
    var self = this;
    // Back/forward cache restores the page as it was left: start fresh then too
    window.addEventListener('pageshow', function (e) { if (e.persisted) self.resetCustomForm(true); });
  }

  // Fresh custom form: clears anything the browser refilled after a refresh. Contact details pre-filled
  // for a logged-in customer (the value="" in the snippet) are kept.
  SizeGuide.prototype.resetCustomForm = function (full) {
    var form = qs(this.dialog, '[data-sg-custom-form]');
    if (!form) return;
    qsa(form, 'input, textarea').forEach(function (el) {
      if (el.type === 'checkbox' || el.type === 'radio') el.checked = el.defaultChecked;
      else el.value = el.defaultValue;
      el.removeAttribute('aria-invalid');
    });
    var err = qs(form, '[data-sg-custom-error]');
    if (err) err.hidden = true;
    this.base = null;
    if (full) {
      this.requestRef = null;
      this.sentHere = false;
      this.customOpenedAt = null;
      this.updateGate();
      this.render();
    }
  };

  /* ---------- hide the theme's quantity selector (quantity stays 1) ---------- */
  SizeGuide.prototype.hideQuantity = function () {
    if (!this.data.hideQuantity || !this.form) return;
    var form = this.form, dialog = this.dialog, root = this.root;
    var keep = this.atcButtons();
    // Never hide a box that also holds Add to cart, the size options or the size guide itself
    function holdsSomethingElse(el) {
      if (el.contains(root)) return true;
      for (var k = 0; k < keep.length; k++) if (el.contains(keep[k])) return true;
      return !!el.querySelector('input[type="radio"], select, .shopify-payment-button, [type="submit"]');
    }
    qsa(document, 'input[name="quantity"]').forEach(function (inp) {
      if (inp.form !== form || dialog.contains(inp) || inp.type === 'hidden') return;
      inp.value = '1';
      // Climb to the outermost wrapper that is only about quantity (label, −, input, +)
      var box = inp, el = inp.parentElement;
      while (el && el !== form && !holdsSomethingElse(el)) {
        var name = el.tagName + ' ' + (typeof el.className === 'string' ? el.className : '');
        if (/quantity|qty/i.test(name) || box === inp) box = el;
        else break;
        el = el.parentElement;
      }
      box.style.display = 'none';
      box.setAttribute('data-sg-hidden-qty', '');
      if (inp.id) qsa(document, 'label[for="' + inp.id + '"]').forEach(function (l) {
        if (!box.contains(l)) l.style.display = 'none';
      });
    });
  };

  /* ---------- size required before Add to cart ----------
   * Nothing is pre-selected; Add to cart stays locked (and says so) until the
   * shopper picks a size on the page or in the guide.                         */

  var LOCK_TEXT = 'Select a size';
  var LOCK_TEXT_CUSTOM = 'Enter your measurements';
  var LOCK_TEXT_REQUEST = 'Request custom size';
  var LOCK_TEXT_REQUESTED = 'Custom size requested';
  var LOCK_TEXTS = [LOCK_TEXT, LOCK_TEXT_CUSTOM, LOCK_TEXT_REQUEST, LOCK_TEXT_REQUESTED];

  SizeGuide.prototype.sizeControls = function () {
    var form = this.form, idx = this.data.sizeIndex;
    if (!form) return { radios: [], selects: [] };
    var values = this.data.sizes.concat(this.data.customValue ? [this.data.customValue] : []);
    var scope = form.closest('section, [data-section-id], main') || form;
    function looksLikeSize(el) {
      var fs = el.closest('fieldset'), legend = fs && fs.querySelector('legend');
      var hay = [el.name, el.id, el.getAttribute('data-option-name'), legend && legend.textContent,
        el.getAttribute('data-index') === 'option' + (idx + 1) ? 'size' : ''].join(' ');
      return /size/i.test(hay);
    }
    var dialog = this.dialog;
    return {
      radios: qsa(scope, 'input[type="radio"]').filter(function (r) {
        return !dialog.contains(r) && values.indexOf(r.value) > -1 && looksLikeSize(r);
      }),
      selects: qsa(scope, 'select').filter(function (s) { return !dialog.contains(s) && looksLikeSize(s); })
    };
  };

  SizeGuide.prototype.atcButtons = function () {
    var form = this.form, dialog = this.dialog;
    if (!form) return [];
    return qsa(document, 'button[type="submit"], input[type="submit"], button[name="add"]').filter(function (b) {
      return b.form === form && !dialog.contains(b);
    });
  };

  function labelTarget(btn) {
    if (btn.tagName === 'INPUT') return null;
    if (!btn.children.length) return btn;
    var spans = qsa(btn, 'span').filter(function (s) {
      return !s.children.length && s.textContent.trim() && !s.hidden && getComputedStyle(s).display !== 'none';
    });
    return spans[0] || null;
  }

  // Is "Custom" the size currently picked on the product page?
  SizeGuide.prototype.isCustomPicked = function () {
    var c = this.chosen;
    if (!c && !this.gateActive) {
      var cur = this.currentVariant();
      c = cur && cur.options[this.data.sizeIndex];
    }
    return !!c && c === this.data.customValue;
  };

  SizeGuide.prototype.gateOpen = function () {
    // Consultation flow: a custom size is requested from the guide, never added to the cart
    if (this.consult && this.isCustomPicked()) return false;
    if (!this.gateActive) return true;
    if (!this.chosen) return false;
    // Custom only counts once the measurements have been saved with "Select custom size"
    return this.chosen !== this.data.customValue || !!this.customSaved;
  };

  SizeGuide.prototype.initGate = function () {
    var self = this;
    var choices = this.data.sizes.length + (this.data.customValue ? 1 : 0);
    this.gateActive = !!(this.data.requireSize && this.form && choices > 1);
    this.gateOn = this.gateActive || !!(this.consult && this.form);
    this.status = qs(this.root, '[data-sg-status]');
    if (!this.gateOn) return;

    // A shared link with ?variant= counts as a deliberate choice
    var cur = this.currentVariant();
    if (/[?&]variant=\d+/.test(window.location.search) && cur) this.chosen = cur.options[this.data.sizeIndex];

    var ctl = this.sizeControls();
    if (!this.chosen && this.gateActive) {
      ctl.radios.forEach(function (r) { r.checked = false; });
      ctl.selects.forEach(function (s) {
        var ph = s.querySelector('option[data-sg-placeholder]');
        if (!ph) {
          ph = document.createElement('option');
          ph.value = '';
          ph.textContent = 'Select size';
          ph.disabled = true;
          ph.setAttribute('data-sg-placeholder', '');
          s.insertBefore(ph, s.firstChild);
        }
        s.value = '';
      });
    }

    // Shopper picks a size on the page
    this.form.addEventListener('change', function (e) {
      var t = e.target;
      var c = self.sizeControls();
      if ((c.radios.indexOf(t) > -1 || c.selects.indexOf(t) > -1) && t.value) {
        self.chosen = t.value;
        self.attention(false);
      }
      self.updateGate();
      setTimeout(function () { self.updateGate(); self.hideQuantity(); }, 350); // after the theme re-renders
    });

    // Block Add to cart / Buy it now until a size is chosen. Capture phase, so this runs before theme scripts.
    this.form.addEventListener('submit', function (e) {
      if (self.gateOpen()) return;
      e.preventDefault();
      e.stopImmediatePropagation();
      self.nudge();
    }, true);
    document.addEventListener('click', function (e) {
      if (self.gateOpen()) return;
      var b = e.target.closest && e.target.closest('button, input[type="submit"]');
      if (!b || self.dialog.contains(b)) return;
      var isAtc = self.atcButtons().indexOf(b) > -1;
      var isBuyNow = b.closest('.shopify-payment-button') && self.form.contains(b);
      if (!isAtc && !isBuyNow) return;
      e.preventDefault();
      e.stopImmediatePropagation();
      self.nudge();
    }, true);

    this.updateGate();
  };

  SizeGuide.prototype.updateGate = function () {
    if (!this.gateOn) return;
    var open = this.gateOpen();
    var isCustom = this.isCustomPicked();
    this.form.classList.toggle('sg-locked', !open);

    // Add to cart keeps its own label. It's disabled until a size is chosen, and while Custom is picked
    // (a custom size is requested from the guide, never added to the cart).
    this.atcButtons().forEach(function (b) {
      b.classList.toggle('sg-atc-locked', !open);
      if (!open) {
        if (!b.disabled) { b.disabled = true; b.setAttribute('data-sg-disabled', ''); }
      } else if (b.hasAttribute('data-sg-disabled')) {
        // Only undo our own disabling (the theme also disables Add to cart for sold-out variants)
        b.disabled = false;
        b.removeAttribute('data-sg-disabled');
      }
      // Put back a label changed by an older version of this script
      var el = labelTarget(b);
      if (b.tagName === 'INPUT') {
        if (b.hasAttribute('data-sg-orig')) {
          if (LOCK_TEXTS.indexOf(b.value) > -1) b.value = b.getAttribute('data-sg-orig');
          b.removeAttribute('data-sg-orig');
        }
      } else if (el && el.hasAttribute('data-sg-orig')) {
        if (LOCK_TEXTS.indexOf(el.textContent.trim()) > -1) el.textContent = el.getAttribute('data-sg-orig');
        el.removeAttribute('data-sg-orig');
      }
    });

    var st = this.status;
    if (!st) return;
    var tick = '<svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><path d="M5 12.5l4.5 4.5L19 7.5"/></svg>';
    if (this.consult && isCustom) {
      st.hidden = false;
      if (this.requestRef) {
        st.className = 'sg-status sg-status--ok';
        st.innerHTML = tick + '<span>Custom size request sent · ' + esc(this.requestRef) + '</span>';
      } else {
        st.hidden = true;   // no "Custom size: send us your measurements · no payment now" line
      }
      return;
    }
    if (!this.gateActive) { st.hidden = true; return; }
    st.hidden = false;
    if (open) {
      st.className = 'sg-status sg-status--ok';
      st.innerHTML = isCustom
        ? tick + '<span>Custom size selected</span><span aria-hidden="true">·</span><button type="button" class="sg-link" data-size-guide-open="custom">edit measurements</button>'
        : tick + '<span>Size ' + esc(this.chosen || '') + ' selected</span>';
    } else if (isCustom) {
      st.className = 'sg-status sg-status--alert';
      st.innerHTML = '<span>Custom size: </span><button type="button" class="sg-link" data-size-guide-open="custom">enter your measurements</button>';
    } else if (!st.classList.contains('sg-status--alert')) {
      st.className = 'sg-status';
      st.textContent = 'Select a size to add to cart';
    }
  };

  // Shopper tried Add to cart without a size: say so and point at the sizes
  SizeGuide.prototype.nudge = function () {
    if (this.isCustomPicked()) { this.open('custom'); return; }
    var st = this.status;
    if (st) {
      st.hidden = false;
      st.className = 'sg-status sg-status--alert';
      st.textContent = 'Please select a size first';
    }
    this.attention(true);
  };

  SizeGuide.prototype.attention = function (on) {
    // Inline size buttons: shake those instead of the theme's (hidden) selector
    if (this.picker) {
      var row = this.pillsBox;
      if (!on) { row.classList.remove('sg-attention'); return; }
      row.classList.remove('sg-attention');
      void row.offsetWidth;
      row.classList.add('sg-attention');
      row.scrollIntoView({ block: 'center', behavior: 'smooth' });
      var firstOk = qs(row, '.sg-size:not(.is-out)');
      if (firstOk) { try { firstOk.focus({ preventScroll: true }); } catch (e) { firstOk.focus(); } }
      return;
    }
    var ctl = this.sizeControls();
    var first = ctl.radios[0] || ctl.selects[0];
    var box = first ? (first.closest('fieldset') || first.parentElement) : null;
    if (!on) {
      if (this.attentionBox) this.attentionBox.classList.remove('sg-attention');
      return;
    }
    if (!box) { this.open('body'); return; } // no visible size picker: open the guide instead
    this.attentionBox = box;
    box.classList.remove('sg-attention');
    void box.offsetWidth; // restart the shake
    box.classList.add('sg-attention');
    box.scrollIntoView({ block: 'center', behavior: 'smooth' });
    try { first.focus({ preventScroll: true }); } catch (e) { first.focus(); }
  };

  SizeGuide.prototype.labelFor = function (item) {
    if (item.label) return item.label;
    if (item.key === 'bust') return this.data.chestLabel || 'Bust';
    var m = MEASURES[item.key];
    return m ? m.label : item.key.replace(/_/g, ' ').replace(/^\w/, function (c) { return c.toUpperCase(); });
  };

  // How to measure: numbered body diagram + matching steps
  SizeGuide.prototype.buildMeasure = function () {
    var fig = qs(this.dialog, '[data-sg-figure]');
    var list = qs(this.dialog, '[data-sg-steps]');
    if (!fig || !list) return;
    var self = this, g = genderKey(this.data.gender);
    var shapes = '', leaders = '', dots = '', nums = '', names = [];

    var items = this.steps.map(function (item, i) {
      var m = measureInfo(item.key) || {};
      var n = i + 1;
      var label = self.labelFor(item);
      var text = item.text || (m.text && (typeof m.text === 'string' ? m.text : m.text[g])) || '';
      if (m.svg) {
        var s = m.svg, cx = s.side === 'l' ? 16 : 184, x1 = s.side === 'l' ? 28 : 172;
        shapes += s.shape;
        leaders += '<line x1="' + s.x0 + '" y1="' + s.y + '" x2="' + x1 + '" y2="' + s.y + '"/>';
        dots += '<circle cx="' + cx + '" cy="' + s.y + '" r="12"/>';
        nums += '<text x="' + cx + '" y="' + (s.y + 4.5) + '">' + n + '</text>';
      }
      names.push(n + ' ' + label.toLowerCase());
      return '<li><span class="sg-num" aria-hidden="true">' + n + '</span><div><h4>' + esc(label) + '</h4>' +
        (text ? '<p class="sg-muted">' + esc(text) + '</p>' : '') + '</div></li>';
    });

    list.innerHTML = items.join('');
    fig.innerHTML =
      '<svg viewBox="0 0 200 420" role="img" aria-label="' + esc('Body outline marking where to measure: ' + names.join(', ')) + '">' +
      '<path d="M88 60 L88 74 Q62 78 50 92 L38 196 L52 198 L62 124 L66 178 Q58 204 58 226 L66 404 L94 404 L100 254 L106 404 L134 404 L142 226 Q142 204 134 178 L138 124 L148 198 L162 196 L150 92 Q138 78 112 74 L112 60 Z" fill="#fff" stroke="#17191C" stroke-width="2" stroke-linejoin="round"/>' +
      '<circle cx="100" cy="40" r="22" fill="#fff" stroke="#17191C" stroke-width="2"/>' +
      '<g fill="none" stroke="currentColor" stroke-width="2.5" stroke-dasharray="5 3">' + shapes + '</g>' +
      '<g stroke="currentColor" stroke-width="1.5">' + leaders + '</g>' +
      '<g fill="currentColor">' + dots + '</g>' +
      '<g fill="#fff" font-size="13" font-weight="700" text-anchor="middle" font-family="inherit">' + nums + '</g>' +
      '</svg>';
  };

  // Custom size: one input per configured measurement
  SizeGuide.prototype.buildCustomFields = function () {
    var box = qs(this.dialog, '[data-sg-custom-fields]');
    if (!box) return;
    var self = this, uid = this.data.uid || 'x';
    var chartUnit = (this.data.general && this.data.general.unit) || 'in';
    box.innerHTML = this.customFields.map(function (item) {
      var label = self.labelFor(item);
      var id = 'sg-f-' + item.key + '-' + uid;
      // Optional limits, e.g. {"key":"shoulder","min":16,"max":22} — in the chart's unit (or the item's "unit")
      var u = item.unit || chartUnit;
      var minIn = item.min != null && !isNaN(Number(item.min)) ? toIn(Number(item.min), u) : null;
      var maxIn = item.max != null && !isNaN(Number(item.max)) ? toIn(Number(item.max), u) : null;
      return '<div class="sg-field">' +
        '<label for="' + id + '">' + esc(label) + ' <span class="sg-u">(<span data-sg-unit-text>in</span>)' +
        (item.required ? '' : ' · optional') + '</span></label>' +
        // form="…" detaches the input from the product form so it can't block Add to cart
        '<input id="' + id + '" form="sg-detached-' + uid + '" type="number" inputmode="decimal" min="0" step="0.25"' +
        ' data-sg-field="' + esc(item.key) + '" data-sg-label="' + esc(label) + '"' +
        (item.column ? ' data-sg-column="' + esc(item.column) + '"' : '') +
        (minIn != null ? ' data-sg-min-in="' + minIn + '"' : '') +
        (maxIn != null ? ' data-sg-max-in="' + maxIn + '"' : '') +

        (item.required ? ' data-sg-required="true"' : '') + '>' +

        '</div>';
    }).join('');
  };

  // Allowed range for a custom field in the unit currently shown, e.g. { min: 16, max: 22 }
  SizeGuide.prototype.fieldRange = function (inp) {
    var a = inp.getAttribute('data-sg-min-in'), b = inp.getAttribute('data-sg-max-in');
    return {
      min: a != null ? fromIn(Number(a), this.unit) : null,
      max: b != null ? fromIn(Number(b), this.unit) : null
    };
  };

  // '' when the value is fine (or empty), otherwise the message to show
  SizeGuide.prototype.rangeProblem = function (inp) {
    var v = parseFloat(inp.value);
    if (isNaN(v)) return '';
    var r = this.fieldRange(inp), u = this.unit, label = inp.getAttribute('data-sg-label');
    if ((r.min != null && v < r.min) || (r.max != null && v > r.max)) {
      if (r.min != null && r.max != null) return label + ' must be between ' + r.min + ' and ' + r.max + ' ' + u + '.';
      if (r.min != null) return label + ' must be at least ' + r.min + ' ' + u + '.';
      return label + ' must be at most ' + r.max + ' ' + u + '.';
    }
    return '';
  };

  SizeGuide.prototype.markRange = function (inp) {
    var hint = inp.parentElement && qs(inp.parentElement, '[data-sg-range]');
    var bad = !!this.rangeProblem(inp);
    if (bad) inp.setAttribute('aria-invalid', 'true');
    else if (inp.getAttribute('aria-invalid') && parseFloat(inp.value) > 0) inp.removeAttribute('aria-invalid');
    if (hint) hint.classList.toggle('sg-hint--bad', bad);
    return !bad;
  };

  /* ---------- product form + variants ---------- */

  SizeGuide.prototype.findProductForm = function () {
    var sel = this.root.getAttribute('data-product-form');
    if (sel) return document.querySelector(sel);
    var scope = this.root.closest('section, [data-section-id], main') || document;
    return scope.querySelector('form[action*="/cart/add"]') || document.querySelector('form[action*="/cart/add"]');
  };

  SizeGuide.prototype.currentVariant = function () {
    var input = this.form && this.form.querySelector('[name="id"]');
    var id = input ? Number(input.value) : null;
    var vs = this.data.variants;
    for (var i = 0; i < vs.length; i++) if (vs[i].id === id) return vs[i];
    return vs[0] || null;
  };

  // The variant with this size and the same other options (e.g. colour) as the current selection
  SizeGuide.prototype.variantFor = function (size) {
    var cur = this.currentVariant();
    var idx = this.data.sizeIndex;
    var vs = this.data.variants;
    for (var i = 0; i < vs.length; i++) {
      var v = vs[i];
      if (v.options[idx] !== size) continue;
      var same = true;
      if (cur) {
        for (var j = 0; j < v.options.length; j++) {
          if (j !== idx && v.options[j] !== cur.options[j]) { same = false; break; }
        }
      }
      if (same) return v;
    }
    return null;
  };

  SizeGuide.prototype.stock = function (size) {
    var v = this.variantFor(size);
    if (!v) return { st: 'out', label: 'Unavailable' };
    if (!v.available) return { st: 'out', label: 'Sold out' };
    if (v.qty != null && v.qty > 0 && v.qty <= this.data.lowStock) return { st: 'low', label: 'Only ' + v.qty + ' left' };
    return { st: 'in', label: 'In stock' };
  };

  // Push the chosen size into the theme's own selector
  SizeGuide.prototype.selectInTheme = function (size) {
    var form = this.form;
    var scope = (form && (form.closest('section, [data-section-id], main') || form)) || document;
    var variant = this.variantFor(size);
    var done = false;

    var radios = qsa(scope, 'input[type="radio"]').filter(function (r) {
      return r.value === size && /size/i.test(r.name + ' ' + (r.id || ''));
    });
    if (radios.length) { radios[0].click(); done = true; }

    if (!done) {
      var select = qsa(scope, 'select').filter(function (s) { return /size/i.test(s.name + ' ' + (s.id || '')); })[0];
      if (select) {
        select.value = size;
        select.dispatchEvent(new Event('change', { bubbles: true }));
        done = true;
      }
    }

    if (!done && variant && form) {
      var idInput = form.querySelector('[name="id"]');
      if (idInput) {
        idInput.value = variant.id;
        idInput.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }

    this.chosen = size;
    this.attention(false);
    this.updateGate();
    this.root.dispatchEvent(new CustomEvent('size-guide:select', { bubbles: true, detail: { size: size, variant: variant } }));
  };

  /* ---------- open / close / events ---------- */

  SizeGuide.prototype.bind = function () {
    var self = this, d = this.dialog;

    qsa(this.root, '[data-sg-open]').forEach(function (b) {
      // "Size chart" always opens on the size table, even if the custom form was the last thing shown
      b.addEventListener('click', function () { self.open(self.tab === 'custom' ? (self.data.startTab || 'body') : undefined); });
    });

    d.addEventListener('close', function () {
      document.documentElement.classList.remove('sg-lock');
      // Closing the guide clears the custom form: next time it opens empty (nothing is kept).
      // The "Custom size request sent · #D…" line on the page stays as the confirmation.
      self.resetCustomForm();
      self.sentHere = false;
      self.customOpenedAt = null;
      self.render();
    });

    d.addEventListener('click', function (e) {
      if (e.target === d) { self.close(); return; } // backdrop
      var t = e.target.closest('button');
      if (!t || !d.contains(t)) return;
      if (t.hasAttribute('data-sg-close')) return self.close();
      if (t.hasAttribute('data-sg-tab')) return self.setTab(t.getAttribute('data-sg-tab'));
      if (t.hasAttribute('data-sg-goto')) {
        self.setTab(t.getAttribute('data-sg-goto'), true);
        var target = t.getAttribute('data-sg-scroll') && qs(d, t.getAttribute('data-sg-scroll'));
        if (target) target.scrollIntoView({ block: 'start' });
        return;
      }
      if (t.hasAttribute('data-sg-unit')) return self.setUnit(t.getAttribute('data-sg-unit'));
      if (t.hasAttribute('data-sg-size')) { self.size = t.getAttribute('data-sg-size'); return self.render(); }
      if (t.hasAttribute('data-sg-pick')) { self.size = t.getAttribute('data-sg-pick'); return self.render(); }
      if (t.hasAttribute('data-sg-base')) return self.fillFromBase(t.getAttribute('data-sg-base'));
      if (t.hasAttribute('data-sg-cta')) return self.cta();
    });

    qsa(d, '[data-sg-check]').forEach(function (i) {
      i.addEventListener('input', function () { self.renderCheck(); });
    });

    // Custom form is a div (it can sit inside the product <form>), so handle Enter ourselves
    // and stop it submitting the product form underneath
    var cf = qs(d, '[data-sg-custom-form]');
    if (cf) {
      cf.addEventListener('input', function (e) {
        if (!e.target.hasAttribute('data-sg-field')) return;
        // While typing, only clear an error once the value is acceptable (don't flag "1" on the way to "16")
        if (e.target.getAttribute('aria-invalid') && parseFloat(e.target.value) > 0 && !self.rangeProblem(e.target)) self.markRange(e.target);
      });
      // When the shopper leaves the box, flag a value outside the allowed range
      cf.addEventListener('change', function (e) {
        if (e.target.hasAttribute('data-sg-field')) self.markRange(e.target);
      });
      cf.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' && e.target.tagName === 'INPUT' && e.target.type !== 'checkbox') {
          e.preventDefault();
          self.submitCustom(cf);
        }
      });
    }
    qsa(d, '[data-sg-check]').forEach(function (i) {
      i.addEventListener('keydown', function (e) { if (e.key === 'Enter') e.preventDefault(); });
    });

    var tablist = qs(d, '[role="tablist"]');
    if (tablist) {
      tablist.addEventListener('keydown', function (e) {
        if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') return;
        var tabs = qsa(tablist, '[role="tab"]');
        var i = tabs.indexOf(document.activeElement);
        if (i < 0) return;
        var next = tabs[(i + (e.key === 'ArrowRight' ? 1 : -1) + tabs.length) % tabs.length];
        next.focus();
        next.click();
        e.preventDefault();
      });
    }

    // Choosing "Custom" in the theme's own size selector opens the custom form (unless measurements
    // are already saved). Choosing S / M / L drops any saved custom measurements.
    if (this.form && this.data.customValue) {
      this.form.addEventListener('change', function (e) {
        if (e.target && e.target.hasAttribute && e.target.hasAttribute('data-sg-prop')) return;
        // Edits inside the guide (e.g. the note box losing focus when × is tapped) aren't size changes
        if (e.target && d.contains(e.target)) return;
        setTimeout(function () {
          var v = self.currentVariant();
          var isCustom = v && v.options[self.data.sizeIndex] === self.data.customValue;
          if (isCustom && !self.customSaved && !d.open) self.open('custom');
          if (!isCustom && self.customSaved) self.clearCustomProps();
        }, 60);
      });
    }
  };

  SizeGuide.prototype.open = function (tab) {
    var cur = this.currentVariant();
    var curSize = cur && cur.options[this.data.sizeIndex];
    var sizes = this.data.sizes;
    // While no size has been chosen on the page, don't pretend one is selected in the guide either
    if (this.gateActive && !this.chosen) curSize = null;
    if (sizes.indexOf(curSize) > -1) this.size = curSize;
    else if (!this.size && !this.gateActive) this.size = sizes[Math.floor((sizes.length - 1) / 2)] || null;
    if (tab) this.setTab(tab); else this.render();
    if (typeof this.dialog.showModal === 'function') this.dialog.showModal();
    else this.dialog.setAttribute('open', '');
    document.documentElement.classList.add('sg-lock');
  };

  SizeGuide.prototype.close = function () {
    if (typeof this.dialog.close === 'function') this.dialog.close();
    else this.dialog.removeAttribute('open');
    document.documentElement.classList.remove('sg-lock');
  };

  SizeGuide.prototype.setTab = function (tab, focus) {
    if (!qs(this.dialog, '[data-sg-panel="' + tab + '"]')) return;
    // Coming back to the custom form after a request was sent: start a fresh form
    // (the "Request received" page only shows right after sending)
    if (tab === 'custom' && this.sentHere) this.resetCustomForm(true);
    this.tab = tab;
    if (tab === 'custom' && this.consult) {
      if (!this.customOpenedAt) this.customOpenedAt = Date.now();
      captchaSetup(String(this.data.requestUrl || '').replace(/\/[^\/]*$/, ''));
    }
    this.render();
    var body = qs(this.dialog, '.sg-body');
    if (body) body.scrollTop = 0;
    if (focus) {
      // Panels without a tab (the custom size form) get focus on their first control instead
      var btn = qs(this.dialog, '[data-sg-tab="' + tab + '"]') ||
        qs(this.dialog, '[data-sg-panel="' + tab + '"] button, [data-sg-panel="' + tab + '"] input');
      if (btn) btn.focus();
    }
  };

  SizeGuide.prototype.setUnit = function (unit) {
    if (unit === this.unit) return;
    var from = this.unit;
    // Convert anything already typed so the shopper's numbers keep their meaning
    qsa(this.dialog, '[data-sg-check], [data-sg-field]').forEach(function (inp) {
      var v = parseFloat(inp.value);
      if (!isNaN(v)) inp.value = String(fromIn(toIn(v, from), unit));
    });
    this.unit = unit;
    this.render();
  };

  /* ---------- rendering ---------- */

  SizeGuide.prototype.render = function () {
    var d = this.dialog, self = this;
    qsa(d, '[data-sg-tab]').forEach(function (b) {
      var on = b.getAttribute('data-sg-tab') === self.tab;
      b.setAttribute('aria-selected', on ? 'true' : 'false');
      b.tabIndex = on ? 0 : -1;
    });
    qsa(d, '[data-sg-panel]').forEach(function (p) { p.hidden = p.getAttribute('data-sg-panel') !== self.tab; });
    qsa(d, '[data-sg-unit]').forEach(function (b) {
      b.setAttribute('aria-pressed', b.getAttribute('data-sg-unit') === self.unit ? 'true' : 'false');
    });
    qsa(d, '[data-sg-unit-text]').forEach(function (el) { el.textContent = self.unit; });
    qsa(d, '[data-sg-unit-long]').forEach(function (el) { el.textContent = self.unit === 'cm' ? 'centimetres' : 'inches'; });
    qsa(d, '[data-sg-tol]').forEach(function (el) { el.textContent = self.unit === 'cm' ? '±1 cm' : '±½ in'; });
    this.renderAvailability();
    this.renderProduct();
    this.renderBody();
    this.renderCheck();
    this.renderCustom();
    this.renderCta();
    this.renderPicker();
  };

  // Stock chips / sold-out callout were removed from the popup; kept as a no-op so older markup doesn't break
  SizeGuide.prototype.renderAvailability = function () {};

  // One table row, shared by the Body and Garment tables so both look and behave the same.
  // A size the shopper can't buy (sold out, or not offered in this colour) is greyed out and can't be picked.
  SizeGuide.prototype.sizeRow = function (size, cellsHtml) {
    var offered = this.data.sizes.indexOf(size) > -1;
    var out = !offered || this.stock(size).st === 'out';
    var sel = !out && size === this.size;
    return '<tr class="' + (sel ? 'is-selected' : '') + (out ? ' is-out' : '') + '">' +
      '<th scope="row"><button type="button" class="sg-pill" data-sg-size="' + esc(size) + '" aria-pressed="' + sel + '"' +
      (out ? ' disabled aria-label="' + esc(size) + ', not available"' : '') + '>' + esc(size) + '</button></th>' +
      cellsHtml + '</tr>';
  };

  // Last row of the Body and Garment tables when the product offers a custom size: opens the custom form
  SizeGuide.prototype.customRow = function (cols) {
    if (!this.data.customValue) return '';
    var name = esc(this.data.customValue);
    return '<tr class="sg-row-custom">' +
      '<th scope="row"><button type="button" class="sg-pill sg-pill--custom" data-sg-goto="custom" aria-label="' + name + ' size: order one made to your measurements">' + name + '</button></th>' +
      '<td colspan="' + cols + '"><div class="sg-rc">' +
        '<p class="sg-rc-text"><strong>Made to your measurements</strong> <span>Nothing to pay until we confirm</span></p>' +
        '<button type="button" class="sg-btn sg-btn--outline" data-sg-goto="custom">Order custom size</button>' +
      '</div></td></tr>';
  };

  SizeGuide.prototype.renderProduct = function () {
    var P = this.data.product, box = qs(this.dialog, '[data-sg-product-table]');
    if (!P || !box) return;
    var self = this, pu = P.unit || 'in', u = this.unit;

    var head = '<tr><th scope="col">Size</th>' + P.columns.map(function (c) {
      return '<th scope="col">' + esc(c) + '</th>';
    }).join('') + '</tr>';

    var rows = this.data.sizes.filter(function (z) { return P.sizes && P.sizes[z]; }).map(function (z) {
      return self.sizeRow(z, P.columns.map(function (c, i) {
        var v = P.sizes[z][i];
        return '<td>' + (v == null ? '–' : esc(fmt(v, pu, u))) + '</td>';
      }).join(''));
    }).join('');

    rows += this.customRow(P.columns.length);
    box.innerHTML = '<table class="sg-table"><caption class="sg-vh">Garment measurements in ' + u + '</caption><thead>' + head + '</thead><tbody>' + rows + '</tbody></table>';
  };

  /* ---------- body chart helpers ----------
   * A chart row looks like  { "size": "S", "chest": 38, "waist": [30, 32], "hip": 39 }
   * Each measurement is a single number or a [min, max] range. Columns come from the keys. */

  function chartKeys(G) {
    var keys = [];
    (G && G.sizes || []).forEach(function (r) {
      Object.keys(r).forEach(function (k) {
        if (k !== 'size' && k !== 'label' && keys.indexOf(k) < 0 && (typeof r[k] === 'number' || Array.isArray(r[k]))) keys.push(k);
      });
    });
    return keys;
  }

  // Row value with bust/chest treated as the same measurement
  function rowValue(row, key) {
    if (!row) return null;
    if (row[key] != null) return row[key];
    if (key === 'bust' && row.chest != null) return row.chest;
    if (key === 'chest' && row.bust != null) return row.bust;
    return null;
  }

  function keyLabel(key) {
    var m = MEASURES[key];
    if (m && m.label) return m.label;
    if (key === 'bust') return 'Bust';
    return key.replace(/_/g, ' ').replace(/^\w/, function (c) { return c.toUpperCase(); });
  }

  /* ---------- Find my size rules ----------
   * Defaults below; any chart can override them with a "rules" block in its chart JSON:
   *   {"unit":"in","rules":{"beyond_range":1,"when_between":"larger"},"sizes":[…]}
   * Distances are in the chart's unit.                                                  */
  var RULE_DEFAULTS = {
    beyond_range: 1,                 // up to this far past the smallest / largest size still counts as that size
    boundary: 0.2,                   // this close to the line between two sizes = "between sizes"
    single_value_spread: 'half_gap', // single numbers cover halfway to the next size, or a number: ± that much
    when_between: 'larger',          // between two sizes → "larger" or "smaller"
    combine: 'largest',              // measurements point to different sizes → "largest", "smallest" or "priority"
    priority: [],                    // for combine "priority": e.g. ["chest", "waist"] — first one entered decides
    custom_when_sizes_apart: 2,      // measurements this many sizes apart → suggest custom (0 = never)
    ignore: [],                      // in the chart but not asked in Find my size, e.g. ["shoulder"]
    required: []                     // must be filled before a result shows, e.g. ["chest"]
  };

  function rulesFor(G) {
    var r = {}, src = (G && G.rules) || {}, unit = (G && G.unit) || 'in';
    Object.keys(RULE_DEFAULTS).forEach(function (k) { r[k] = src[k] != null ? src[k] : RULE_DEFAULTS[k]; });
    r.tol = toIn(Number(r.beyond_range) || 0, unit);
    r.eps = toIn(Number(r.boundary) || 0, unit);
    r.spread = typeof r.single_value_spread === 'number' ? toIn(r.single_value_spread, unit) : null;
    r.pickSmaller = String(r.when_between).toLowerCase() === 'smaller';
    ['priority', 'ignore', 'required'].forEach(function (k) {
      // trim: "shoulder " with a stray space still means shoulder
      r[k] = (Array.isArray(r[k]) ? r[k] : []).map(function (x) { return String(x).trim().toLowerCase(); }).filter(Boolean);
    });
    // "chest" and "bust" are interchangeable in the lists
    function alias(list) {
      list.slice().forEach(function (x) {
        if (x === 'chest' && list.indexOf('bust') < 0) list.push('bust');
        if (x === 'bust' && list.indexOf('chest') < 0) list.push('chest');
      });
    }
    alias(r.ignore); alias(r.required);
    return r;
  }

  // Turn one measurement column into an interval per size (in inches).
  // Ranges are used as given. A single number covers half the gap to its neighbours
  // (e.g. S 38 / M 40 / L 42  →  S 37–39, M 39–41, L 41–43), or ± rules.single_value_spread.
  function intervals(rows, key, unit, rules) {
    var singles = rows.map(function (r) { return r[key]; })
      .filter(function (v) { return typeof v === 'number'; })
      .map(function (v) { return toIn(v, unit); })
      .sort(function (a, b) { return a - b; });
    var gap = Infinity;
    for (var i = 0; i + 1 < singles.length; i++) {
      var d = singles[i + 1] - singles[i];
      if (d > 0 && d < gap) gap = d;
    }
    var half = rules && rules.spread != null ? rules.spread : (isFinite(gap) ? gap / 2 : 1);
    var out = [];
    rows.forEach(function (r, idx) {
      var v = r[key];
      if (Array.isArray(v)) out.push({ i: idx, lo: toIn(v[0], unit), hi: toIn(v[1], unit) });
      else if (typeof v === 'number') out.push({ i: idx, lo: toIn(v, unit) - half, hi: toIn(v, unit) + half });
    });
    return out;
  }

  // Where one measurement (inches) lands: { i } a size, { i, between } on/near a boundary, or { out }
  function fitOne(x, R, rules) {
    rules = rules || rulesFor(null);
    var EPS = rules.eps;  // "on the boundary" band (also absorbs rounding when typing in cm)
    var TOL = rules.tol;  // how far past the smallest / largest size still counts as that size
    var pick = rules.pickSmaller ? Math.min : Math.max; // which size wins when between two
    if (!R.length) return null;
    var min = Math.min.apply(null, R.map(function (r) { return r.lo; }));
    var max = Math.max.apply(null, R.map(function (r) { return r.hi; }));
    if (x < min - TOL) return { out: 'below' };
    if (x > max + TOL) return { out: 'above' };
    var inside = R.filter(function (r) { return x >= r.lo - EPS && x <= r.hi + EPS; });
    if (inside.length === 1) return { i: inside[0].i };
    if (inside.length > 1) return { i: pick.apply(null, inside.map(function (r) { return r.i; })), between: true };
    // In a gap between sizes, or just past either end: nearest size (rules.when_between on a tie)
    function dist(r) { return x < r.lo ? r.lo - x : x - r.hi; }
    var best = Math.min.apply(null, R.map(dist));
    var near = R.filter(function (r) { return dist(r) - best <= 0.25; });
    return { i: pick.apply(null, near.map(function (r) { return r.i; })), between: x >= min && x <= max };
  }

  // Find my size inputs: one per measurement in the chart
  SizeGuide.prototype.buildCheckFields = function () {
    var box = qs(this.dialog, '[data-sg-check-fields]');
    var G = this.data.general;
    if (!box || !G) return;
    var uid = this.data.uid || 'x';
    var ignore = rulesFor(G).ignore;
    var keys = chartKeys(G).filter(function (k) { return ignore.indexOf(k.toLowerCase()) < 0; });
    box.style.gridTemplateColumns = 'repeat(' + Math.max(1, Math.min(keys.length, 4)) + ', minmax(0, 1fr))';
    box.innerHTML = keys.map(function (k) {
      var id = 'sg-c-' + k + '-' + uid;
      return '<div class="sg-field">' +
        '<label for="' + id + '">' + esc(keyLabel(k)) + ' <span class="sg-u">(<span data-sg-unit-text>in</span>)</span></label>' +
        '<input id="' + id + '" form="sg-detached-' + uid + '" type="number" inputmode="decimal" min="0" step="0.5" data-sg-check="' + esc(k) + '">' +
        '</div>';
    }).join('');
  };

  SizeGuide.prototype.renderBody = function () {
    var G = this.data.general, box = qs(this.dialog, '[data-sg-body-table]');
    if (!G || !box) return;
    var self = this, gu = G.unit || 'in', u = this.unit;
    var keys = chartKeys(G);
    var hasLabel = !!G.size_label;
    var head = '<tr><th scope="col">Size</th>' + (hasLabel ? '<th scope="col">' + esc(G.size_label) + '</th>' : '') +
      keys.map(function (k) { return '<th scope="col">' + esc(keyLabel(k)) + '</th>'; }).join('') + '</tr>';
    var rows = G.sizes.map(function (r) {
      return self.sizeRow(r.size,
        (hasLabel ? '<td>' + esc(r.label || '') + '</td>' : '') +
        keys.map(function (k) { return '<td>' + (r[k] == null ? '–' : esc(fmt(r[k], gu, u))) + '</td>'; }).join(''));
    }).join('');
    rows += this.customRow(keys.length + (hasLabel ? 1 : 0));
    box.innerHTML = '<table class="sg-table"><caption class="sg-vh">Body measurements in ' + u + '</caption><thead>' + head + '</thead><tbody>' + rows + '</tbody></table>';
  };

  // Find my size
  SizeGuide.prototype.renderCheck = function () {
    var G = this.data.general, out = qs(this.dialog, '[data-sg-check-result]');
    if (!G || !out || !G.sizes || !G.sizes.length) return;
    var self = this, gu = G.unit || 'in', rows = G.sizes;
    var names = rows.map(function (r) { return r.size; });
    var first = names[0], last = names[names.length - 1];
    var hasCustom = !!this.data.customValue;
    var rules = rulesFor(G);
    var keys = chartKeys(G).filter(function (k) { return rules.ignore.indexOf(k.toLowerCase()) < 0; });

    var res = [], missing = [];
    keys.forEach(function (k) {
      var input = qs(self.dialog, '[data-sg-check="' + k + '"]');
      var v = input ? parseFloat(input.value) : NaN;
      if (!isNaN(v) && v > 0) {
        var r = fitOne(toIn(v, self.unit), intervals(rows, k, gu, rules), rules);
        if (!r) return;
        r.key = k.toLowerCase();
        r.label = keyLabel(k);
        r.raw = input.value;
        res.push(r);
      } else if (rules.required.indexOf(k.toLowerCase()) > -1) {
        missing.push(keyLabel(k).toLowerCase());
      }
    });

    var tone = 'none', title, detail, btn = '';
    var customBtn = hasCustom ? '<button type="button" class="sg-btn sg-btn--outline" data-sg-goto="custom">Order a custom size</button>' : '';

    if (!res.length || missing.length) {
      title = 'Enter your measurements';
      detail = missing.length
        ? 'Please add your ' + orList(missing).replace(/ or ([^ ]+)$/, ' and $1') + ' to see your size.'
        : 'We’ll match them to ' + orList(names) + '.';
    } else {
      var o = res.filter(function (r) { return r.out; })[0];
      if (o) {
        tone = 'custom';
        title = hasCustom ? 'A custom size will fit you best' : 'This product may not fit well';
        detail = 'Your ' + o.label.toLowerCase() + ' (' + o.raw + ' ' + this.unit + ') is ' +
          (o.out === 'above' ? 'above our ' + last : 'below our ' + first) + ' range.';
        btn = customBtn;
      } else {
        var idxs = res.map(function (r) { return r.i; });
        var hi = Math.max.apply(null, idxs), lo = Math.min.apply(null, idxs);
        var between = res.some(function (r) { return r.between; });
        var apart = Number(rules.custom_when_sizes_apart) || 0;
        var combine = String(rules.combine).toLowerCase();

        // Which size to recommend when the measurements disagree
        var recIdx = hi, decider = null;
        if (combine === 'smallest') recIdx = lo;
        else if (combine === 'priority') {
          for (var p = 0; p < rules.priority.length && !decider; p++) {
            decider = res.filter(function (r) { return r.key === rules.priority[p] || (rules.priority[p] === 'chest' && r.key === 'bust') || (rules.priority[p] === 'bust' && r.key === 'chest'); })[0] || null;
          }
          decider = decider || res[0];
          recIdx = decider.i;
        }
        var rec = names[recIdx];

        if (apart > 0 && hi - lo >= apart) {
          tone = 'custom';
          title = hasCustom ? 'A custom size will fit you best' : 'You’re between several sizes';
          detail = 'Your measurements range from ' + names[lo] + ' to ' + names[hi] + ', so no single size fits well.';
          btn = customBtn;
        } else {
          var allLabels = orList(res.map(function (r) { return r.label.toLowerCase(); })).replace(/ or ([^ ]+)$/, ' and $1');
          if (hi === lo && !between) {
            detail = 'Your ' + allLabels + (res.length > 2 ? ' all fit ' : res.length === 2 ? ' both fit ' : ' fits ') + rec + '.';
          } else if (decider) {
            detail = 'Based on your ' + decider.label.toLowerCase() + ', ' + rec + ' fits best.' +
              (decider.between ? ' You’re close to the next size.' : '');
          } else {
            detail = 'You’re between sizes — size ' + (recIdx === lo && hi !== lo || (hi === lo && rules.pickSmaller) ? 'down' : 'up') +
              ' to ' + rec + ' for a comfortable fit.';
          }
          title = 'You’re a size ' + rec;
          var st = this.stock(rec);
          if (st.st === 'out' && hasCustom) {
            tone = 'custom';
            detail += ' ' + rec + ' is sold out in this product, but we can make it for you.';
            btn = customBtn;
          } else if (st.st === 'out') {
            tone = 'none';
            detail += ' ' + rec + ' is sold out right now.';
          } else {
            tone = 'ok';
            btn = '<button type="button" class="sg-btn sg-btn--primary" data-sg-pick="' + esc(rec) + '">' +
              (self.size === rec ? 'Size ' + esc(rec) + ' selected' : 'Select size ' + esc(rec)) + '</button>';
          }
        }
      }
    }

    out.className = 'sg-result sg-result--' + tone;
    out.innerHTML = '<div><strong>' + esc(title) + '</strong><p class="sg-muted">' + esc(detail) + '</p></div>' + btn;
  };

  // Suggested value (in inches) for each custom field when starting from a size:
  // bust / waist / hip from the general body chart, everything else from the product's
  // measurement column of the same name (or the field's "column" setting)
  SizeGuide.prototype.hintsFor = function (size) {
    var G = this.data.general, P = this.data.product, self = this;
    var gRow = G && G.sizes ? G.sizes.filter(function (r) { return r.size === size; })[0] : null;
    var pRow = P && P.sizes ? P.sizes[size] : null;
    var gu = (G && G.unit) || 'in';
    function pcol(names) {
      if (!P || !pRow || !P.columns) return null;
      for (var n = 0; n < names.length; n++) {
        var want = String(names[n]).toLowerCase();
        for (var i = 0; i < P.columns.length; i++) {
          var col = String(P.columns[i]).toLowerCase();
          if ((col === want || col.indexOf(want) === 0) && typeof pRow[i] === 'number') return toIn(pRow[i], P.unit || 'in');
        }
      }
      return null;
    }
    var hints = {};
    qsa(this.dialog, '[data-sg-field]').forEach(function (inp) {
      var key = inp.getAttribute('data-sg-field');
      var gv = rowValue(gRow, key);
      if (gv != null) {
        hints[key] = toIn(mid(gv), gu);
        return;
      }
      var names = [inp.getAttribute('data-sg-column'), inp.getAttribute('data-sg-label'), key.replace(/_/g, ' '), (MEASURES[key] || {}).label]
        .filter(Boolean);
      hints[key] = pcol(names);
    });
    return hints;
  };

  SizeGuide.prototype.renderCustom = function () {
    var form = qs(this.dialog, '[data-sg-custom-form]');
    if (!form) return;
    var self = this;
    var base = this.base || this.size || this.data.sizes[0];
    qsa(form, '[data-sg-base]').forEach(function (b) {
      b.setAttribute('aria-pressed', b.getAttribute('data-sg-base') === self.base ? 'true' : 'false');
    });
    var hints = this.hintsFor(base);
    qsa(form, '[data-sg-field]').forEach(function (inp) {
      var h = hints[inp.getAttribute('data-sg-field')];
      inp.placeholder = h != null ? 'e.g. ' + fromIn(h, self.unit) : '';
      // Allowed range (in the unit shown) under the box, and as the spinner's limits
      var r = self.fieldRange(inp), hint = inp.parentElement && qs(inp.parentElement, '[data-sg-range]');
      if (r.min != null) inp.min = r.min; else inp.min = 0;
      if (r.max != null) inp.max = r.max; else inp.removeAttribute('max');
      if (hint) {
        hint.textContent = r.min != null && r.max != null ? r.min + '–' + r.max + ' ' + self.unit
          : r.min != null ? 'At least ' + r.min + ' ' + self.unit : 'Up to ' + r.max + ' ' + self.unit;
      }
      if (inp.value) self.markRange(inp);
    });
    var cv = this.variantFor(this.data.customValue);
    qsa(this.dialog, '[data-sg-custom-price]').forEach(function (el) { el.textContent = cv ? cv.price : '—'; });
    // After a request is sent, the tab shows the confirmation instead of the form
    var sent = qs(this.dialog, '[data-sg-sent]');
    if (sent) {
      var done = !!(this.consult && this.requestRef && this.sentHere);
      sent.hidden = !done;
      form.hidden = done;
    }
  };

  SizeGuide.prototype.fillFromBase = function (size) {
    var self = this;
    this.base = size;
    var hints = this.hintsFor(size);
    qsa(this.dialog, '[data-sg-field]').forEach(function (inp) {
      var h = hints[inp.getAttribute('data-sg-field')];
      if (h != null) { inp.value = String(fromIn(h, self.unit)); inp.removeAttribute('aria-invalid'); }
    });
    this.renderCustom();
  };

  SizeGuide.prototype.renderCta = function () {
    var btn = qs(this.dialog, '[data-sg-cta]');
    if (!btn) return;
    // "Request received" page: no footer button — the popup's close (×) is enough
    var foot = btn.closest('.sg-foot');
    var sentPage = this.tab === 'custom' && this.consult && !!this.sentHere;
    if (foot) foot.hidden = sentPage;
    var disabled = false, label;
    if (this.tab === 'custom') {
      label = !this.consult ? 'Select custom size' : (this.sentHere ? 'Done' : 'Request consultation');
    } else if (!this.size) {
      label = 'Select a size';
      disabled = true;
    } else if (this.stock(this.size).st === 'out') {
      label = 'Size ' + this.size + ' is sold out';
      disabled = true;
    } else {
      label = 'Select size ' + this.size;
    }
    btn.textContent = label;
    btn.setAttribute('aria-disabled', disabled ? 'true' : 'false');
  };

  SizeGuide.prototype.cta = function () {
    var btn = qs(this.dialog, '[data-sg-cta]');
    if (btn.getAttribute('aria-disabled') === 'true' || btn.getAttribute('aria-busy') === 'true') return;
    if (this.tab === 'custom') {
      if (this.consult && this.sentHere) return this.close();
      var form = qs(this.dialog, '[data-sg-custom-form]');
      if (form) this.submitCustom(form);
      return;
    }
    this.selectInTheme(this.size);
    this.close();
  };

  /* ---------- custom order ---------- */

  SizeGuide.prototype.submitCustom = function (form) {
    if (this.consult) return this.submitRequest(form);
    var self = this;
    var err = qs(form, '[data-sg-custom-error]');
    var btn = qs(this.dialog, '[data-sg-cta]');
    function fail(msg, focusEl) {
      err.textContent = msg;
      err.hidden = false;
      if (focusEl) focusEl.focus();
    }
    err.hidden = true;

    var cv = this.variantFor(this.data.customValue);
    if (!cv) return fail('A custom size isn’t available for this option.');
    if (!cv.available) return fail('Custom orders for this product are paused right now.');

    var props = {}, firstMissing = null, missing = [], rangeMsgs = [], firstBad = null;
    qsa(form, '[data-sg-field]').forEach(function (inp) {
      var label = inp.getAttribute('data-sg-label');
      var v = parseFloat(inp.value);
      inp.removeAttribute('aria-invalid');
      if (isNaN(v) || v <= 0) {
        if (inp.getAttribute('data-sg-required') === 'true') {
          missing.push(label.toLowerCase());
          inp.setAttribute('aria-invalid', 'true');
          firstMissing = firstMissing || inp;
        }
        return;
      }
      var problem = self.rangeProblem(inp);
      if (problem) {
        rangeMsgs.push(problem);
        self.markRange(inp);
        firstBad = firstBad || inp;
        return;
      }
      props[label] = v + ' ' + self.unit;
    });
    if (missing.length) return fail('Please enter your ' + orList(missing).replace(' or ', ' and ') + '.', firstMissing);
    if (rangeMsgs.length) return fail(rangeMsgs.join(' '), firstBad);

    var agree = qs(form, '[data-sg-agree]');
    if (agree && !agree.checked) return fail('Please tick the box to confirm your custom order.', agree);

    var notes = qs(form, '[data-sg-notes]');
    if (notes && notes.value.trim()) props['Notes'] = notes.value.trim();
    if (this.base) props['Started from size'] = this.base;
    props['_custom_order'] = 'yes'; // leading underscore = hidden at checkout, visible in admin

    // Select "Custom" on the product page and attach the measurements to the product form, so the
    // theme's own Add to cart sends them as line item properties. Then close the guide.
    this.writeCustomProps(props);
    this.customSaved = true;
    this.selectInTheme(this.data.customValue);
    this.root.dispatchEvent(new CustomEvent('size-guide:custom-selected', { bubbles: true, detail: { variant: cv, properties: props } }));
    this.close();
  };

  // Hidden properties[...] inputs inside the product form carry the measurements into the cart
  SizeGuide.prototype.writeCustomProps = function (props) {
    var form = this.form;
    if (!form) return;
    this.clearCustomProps(true);
    Object.keys(props).forEach(function (k) {
      var inp = document.createElement('input');
      inp.type = 'hidden';
      inp.name = 'properties[' + k + ']';
      inp.value = props[k];
      inp.setAttribute('data-sg-prop', '');
      form.appendChild(inp);
    });
  };

  SizeGuide.prototype.clearCustomProps = function (keepFlag) {
    if (this.form) qsa(this.form, 'input[data-sg-prop]').forEach(function (i) { i.remove(); });
    if (!keepFlag) {
      this.customSaved = false;
      this.updateGate();
    }
  };

  /* ---------- custom size as a consultation request ----------
   * Sends measurements + contact details to the custom-size app (Shopify app proxy).
   * The app creates a draft order tagged "consultation" — nothing goes in the cart. */

  SizeGuide.prototype.submitRequest = function (form) {
    var self = this;
    var err = qs(form, '[data-sg-custom-error]');
    var btn = qs(this.dialog, '[data-sg-cta]');
    if (btn && btn.getAttribute('aria-busy') === 'true') return;
    function fail(msg, focusEl) {
      err.textContent = msg;
      err.hidden = false;
      if (focusEl) focusEl.focus();
    }
    err.hidden = true;

    // Measurements
    var measurements = [], missing = [], firstMissing = null, rangeMsgs = [], firstBad = null;
    qsa(form, '[data-sg-field]').forEach(function (inp) {
      var label = inp.getAttribute('data-sg-label');
      var v = parseFloat(inp.value);
      inp.removeAttribute('aria-invalid');
      if (isNaN(v) || v <= 0) {
        if (inp.getAttribute('data-sg-required') === 'true') {
          missing.push(label.toLowerCase());
          inp.setAttribute('aria-invalid', 'true');
          firstMissing = firstMissing || inp;
        }
        return;
      }
      var problem = self.rangeProblem(inp);
      if (problem) {
        rangeMsgs.push(problem);
        self.markRange(inp);
        firstBad = firstBad || inp;
        return;
      }
      measurements.push({ key: inp.getAttribute('data-sg-field'), label: label, value: v });
    });
    if (missing.length) return fail('Please enter your ' + orList(missing).replace(' or ', ' and ') + '.', firstMissing);
    if (rangeMsgs.length) return fail(rangeMsgs.join(' '), firstBad);
    if (!measurements.length) return fail('Please enter your measurements.', qs(form, '[data-sg-field]'));

    // Contact details
    function contact(name) { return qs(form, '[data-sg-contact="' + name + '"]'); }
    var nameEl = contact('name'), emailEl = contact('email'), phoneEl = contact('phone');
    [nameEl, emailEl, phoneEl].forEach(function (el) { if (el) el.removeAttribute('aria-invalid'); });
    var name = nameEl ? nameEl.value.trim() : '';
    var email = emailEl ? emailEl.value.trim() : '';
    var phone = phoneEl ? phoneEl.value.trim() : '';
    if (!name) { nameEl.setAttribute('aria-invalid', 'true'); return fail('Please enter your name.', nameEl); }
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(email)) { emailEl.setAttribute('aria-invalid', 'true'); return fail('Please enter a valid email address.', emailEl); }
    if (!/^\+?[0-9][0-9()\-\s]{6,19}$/.test(phone)) { phoneEl.setAttribute('aria-invalid', 'true'); return fail('Please enter a phone number we can reach you on.', phoneEl); }

    var agree = qs(form, '[data-sg-agree]');
    if (agree && !agree.checked) return fail('Please tick the box to confirm.', agree);

    // The other options (e.g. colour) the shopper has picked
    var cur = this.currentVariant(), options = {}, names = this.data.optionNames || [];
    if (cur) cur.options.forEach(function (val, i) {
      if (i !== self.data.sizeIndex && names[i]) options[names[i]] = val;
    });
    var cv = this.variantFor(this.data.customValue);
    var notes = qs(form, '[data-sg-notes]');
    var hp = qs(form, '[data-sg-hp]');

    var payload = {
      product_id: this.data.productId,
      variant_id: cv ? cv.id : null,
      options: options,
      unit: this.unit,
      measurements: measurements,
      started_from: this.base || '',
      notes: notes ? notes.value.trim() : '',
      name: name,
      email: email,
      phone: phone,
      contact_via: '',
      page: window.location.href.split('#')[0],
      website: hp ? hp.value : '',
      elapsed_ms: Date.now() - (this.customOpenedAt || Date.now() - 60000)
    };

    if (btn) { btn.setAttribute('aria-busy', 'true'); btn.textContent = 'Sending…'; }
    var GENERIC = 'Sorry, we couldn’t send your request just now. Please try again, or contact us.';
    var base = String(this.data.requestUrl || '').replace(/\/[^\/]*$/, '');
    CAPTCHA.send(self.data.requestUrl, payload, base, 'custom_size_request').then(function (res) {
      if (!res.ok || !res.j || !res.j.ok) return fail((res.j && res.j.error) || GENERIC);
      self.requestRef = String(res.j.reference || '');
      self.sentHere = true;
      qsa(self.dialog, '[data-sg-ref]').forEach(function (el) { el.textContent = self.requestRef; });
      qsa(self.dialog, '[data-sg-sent-email]').forEach(function (el) { el.textContent = email; });
      self.updateGate();
      self.render();
      var body = qs(self.dialog, '.sg-body');
      if (body) body.scrollTop = 0;
      var title = qs(self.dialog, '[data-sg-sent-title]');
      if (title) title.focus();
      self.root.dispatchEvent(new CustomEvent('size-guide:custom-requested', { bubbles: true, detail: { reference: self.requestRef, request: payload } }));
    }).catch(function () {
      fail(GENERIC);
    }).then(function () {
      if (btn) btn.removeAttribute('aria-busy');
      self.renderCta();
    });
  };

  /* ---------- inline size buttons on the product page ----------
   * A row of size buttons next to "Size chart". Hovering (mouse), focusing (keyboard)
   * or tapping (touch) a size shows its body measurements in a small popover;
   * clicking selects it in the theme's own selector, exactly like the guide's "Select size". */

  SizeGuide.prototype.initPicker = function () {
    var p = qs(this.root, '[data-sg-picker]');
    if (!p || !this.data.inlineSizes) return;
    var self = this;
    this.picker = p;
    this.pillsBox = qs(p, '[data-sg-pills]');
    this.pop = qs(p, '[data-sg-pop]');
    this.popFor = null;
    var hoverable = window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches;
    var showT = null, hideT = null;
    function later(fn, ms) { return setTimeout(fn, ms); }
    function cancel() { clearTimeout(showT); clearTimeout(hideT); }

    // Mouse: show on hover (tiny delay so sweeping across the row doesn't flicker). The popover itself is
    // click-through (pointer-events: none), so it never blocks Add to cart underneath.
    // Pointer events (not mouse events) so a finger tap never counts as a hover on phones
    var lastPointer = hoverable ? 'mouse' : 'touch';
    this.pillsBox.addEventListener('pointerdown', function (e) { lastPointer = e.pointerType || lastPointer; });
    this.pillsBox.addEventListener('pointerover', function (e) {
      if (e.pointerType !== 'mouse') return;
      lastPointer = 'mouse';
      var b = e.target.closest('.sg-size');
      if (!b) return;
      cancel();
      showT = later(function () { self.popAbove = false; self.showPop(b); }, self.popFor ? 0 : 80);
    });
    this.pillsBox.addEventListener('pointerleave', function (e) {
      if (e.pointerType !== 'mouse') return;
      cancel(); hideT = later(function () { self.hidePop(); }, 120);
    });

    // Keyboard: popover follows focus; arrow keys move along the row
    this.pillsBox.addEventListener('focusin', function (e) {
      var b = e.target.closest('.sg-size');
      if (b && b.matches(':focus-visible')) { cancel(); self.showPop(b); }
    });
    this.pillsBox.addEventListener('focusout', function (e) {
      if (e.relatedTarget && self.pillsBox.contains(e.relatedTarget)) return;
      if (!self.pillsBox.matches(':hover')) self.hidePop();
    });
    this.pillsBox.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') { self.hidePop(); return; }
      if (['ArrowRight', 'ArrowLeft', 'ArrowDown', 'ArrowUp'].indexOf(e.key) < 0) return;
      var all = qsa(self.pillsBox, '.sg-size');
      var i = all.indexOf(document.activeElement);
      if (i < 0) return;
      var step = e.key === 'ArrowRight' || e.key === 'ArrowDown' ? 1 : -1;
      all[(i + step + all.length) % all.length].focus();
      e.preventDefault();
    });

    // Click / tap: select. On touch screens the popover opens for the tapped size and stays until you tap elsewhere.
    this.pillsBox.addEventListener('click', function (e) {
      var b = e.target.closest('.sg-size');
      if (!b) return;
      e.preventDefault();
      if (b.hasAttribute('data-sg-choose-custom')) {
        self.hidePop();
        if (self.gateActive && b.getAttribute('aria-pressed') === 'true') { self.deselect(); return; }
        self.selectInTheme(self.data.customValue);
        if (!self.customSaved && !self.dialog.open) self.open('custom');
        return;
      }
      var size = b.getAttribute('data-sg-choose');
      // Second click on the selected size unselects it (only when a size is required, i.e. nothing is pre-selected)
      if (self.gateActive && b.getAttribute('aria-pressed') === 'true') {
        self.deselect();
        if (lastPointer === 'mouse') { if (self.popFor) self.renderPop(); }
        else self.hidePop();
        return;
      }
      var out = b.classList.contains('is-out');
      if (!out) self.selectInTheme(size);
      if (lastPointer === 'mouse') {
        if (!out) self.renderPop(); // mouse: the hover card stays, now marked "Selected"
      } else {
        self.flashPop(b);           // touch: show the card until something else is touched
      }
    });

    // in / cm switch next to "Size chart" (shared with the guide)
    qsa(p, '[data-sg-punit]').forEach(function (u) {
      u.addEventListener('click', function (e) {
        e.preventDefault();
        self.setUnit(u.getAttribute('data-sg-punit'));
        self.renderPicker();
      });
    });

    // Touching or clicking anything outside the size buttons closes the card. pointerdown, not click:
    // iPhone Safari doesn't send a click for taps on plain text or images, so a click listener missed those.
    // Listened for on window, in the capture phase, so the theme's own handlers can't swallow it first.
    function outside(e) {
      if (!self.popFor) return;
      var t = e.target;
      if (t && t.nodeType !== 1) t = t.parentNode;
      // Only a size button itself keeps it open; empty space in the row (e.g. right of Custom) closes it
      var btn = t && t.closest && t.closest('.sg-size');
      if (btn && self.pillsBox.contains(btn)) return;
      self.hidePop();
    }
    ['pointerdown', 'touchstart', 'mousedown'].forEach(function (type) {
      window.addEventListener(type, outside, { capture: true, passive: true });
    });
    // Scrolling the page closes it too
    window.addEventListener('scroll', function () {
      if (self.popFor && Math.abs(window.scrollY - (self.popScrollY || 0)) > 24) self.hidePop();
    }, { passive: true });
    // Leaving the page / switching apps
    document.addEventListener('visibilitychange', function () { if (document.hidden && self.popFor) self.hidePop(); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && self.popFor) self.hidePop(); });
    window.addEventListener('resize', function () { if (self.popFor) self.placePop(); });

    // Stay in sync with the theme (colour changes re-render it) and with picks made in the guide
    if (this.form) {
      this.form.addEventListener('change', function () {
        self.renderPicker();
        setTimeout(function () { self.hideThemeSize(); self.renderPicker(); }, 350);
      });
    }
    this.root.addEventListener('size-guide:select', function () { self.renderPicker(); });

    this.hideThemeSize();
    this.renderPicker();
  };

  // The theme's own size buttons/dropdown, hidden so the page shows one size picker. It stays in the DOM
  // and is still what the cart reads — selectInTheme() drives it.
  SizeGuide.prototype.hideThemeSize = function () {
    if (!this.picker || !this.data.hideThemeSize) return;
    var root = this.root, ctl = this.sizeControls();
    ctl.radios.concat(ctl.selects).forEach(function (el) {
      var box = el.closest('fieldset') ||
        el.closest('.product-form__input, .product-form__option, .selector-wrapper, .variant-wrapper, .product-option') ||
        el.parentElement;
      if (!box || box.contains(root) || box.hasAttribute('data-sg-hidden-size')) return;
      // Never hide a box that holds other options (e.g. colour) as well
      var others = qsa(box, 'select, input[type="radio"]').filter(function (x) {
        return ctl.radios.indexOf(x) < 0 && ctl.selects.indexOf(x) < 0;
      });
      if (others.length) return;
      box.style.display = 'none';
      box.setAttribute('data-sg-hidden-size', '');
    });
  };

  // Back to "no size chosen": clears the theme's size selector, so Add to cart is disabled again
  SizeGuide.prototype.deselect = function () {
    var ctl = this.sizeControls();
    ctl.radios.forEach(function (r) { r.checked = false; });
    ctl.selects.forEach(function (sel) {
      var ph = sel.querySelector('option[data-sg-placeholder]');
      if (!ph) {
        ph = document.createElement('option');
        ph.value = '';
        ph.textContent = 'Select size';
        ph.disabled = true;
        ph.setAttribute('data-sg-placeholder', '');
        sel.insertBefore(ph, sel.firstChild);
      }
      sel.value = '';
    });
    if (this.customSaved) this.clearCustomProps(true);
    this.customSaved = false;
    this.chosen = null;
    this.size = null;
    this.attention(false);
    this.updateGate();
    this.renderPicker();
    this.root.dispatchEvent(new CustomEvent('size-guide:deselect', { bubbles: true }));
  };

  // Size currently picked on the page (null while nothing is chosen)
  SizeGuide.prototype.pickedSize = function () {
    if (this.chosen) return this.chosen;
    if (this.gateActive) return null;
    var v = this.currentVariant();
    return v ? v.options[this.data.sizeIndex] : null;
  };

  SizeGuide.prototype.renderPicker = function () {
    if (!this.picker) return;
    var self = this, picked = this.pickedSize();
    qsa(this.pillsBox, '.sg-size').forEach(function (b) {
      if (b.hasAttribute('data-sg-choose-custom')) {
        b.setAttribute('aria-pressed', picked && picked === self.data.customValue ? 'true' : 'false');
        return;
      }
      var size = b.getAttribute('data-sg-choose');
      var st = self.stock(size).st;
      var out = st === 'out';
      b.classList.toggle('is-out', out);
      b.setAttribute('aria-pressed', !out && picked === size ? 'true' : 'false');
      if (out) b.setAttribute('aria-label', size + ', ' + self.stock(size).label.toLowerCase());
      else b.removeAttribute('aria-label');
    });
    qsa(this.picker, '[data-sg-punit]').forEach(function (u) {
      u.setAttribute('aria-pressed', u.getAttribute('data-sg-punit') === self.unit ? 'true' : 'false');
    });
    var lbl = qs(this.picker, '[data-sg-picked]');
    if (lbl) lbl.textContent = picked ? picked : '';
    if (this.popFor) this.renderPop();
  };

  SizeGuide.prototype.showPop = function (btn) {
    if (!btn) return;
    if (this.popBtn && this.popBtn !== btn) this.popBtn.classList.remove('is-peek');
    this.popBtn = btn;
    this.popFor = btn.hasAttribute('data-sg-choose-custom') ? '__custom' : btn.getAttribute('data-sg-choose');
    if (!this.renderPop()) { this.hidePop(); return; }
    btn.classList.add('is-peek');
    btn.setAttribute('aria-describedby', this.pop.id);
    var wasHidden = this.pop.hidden;
    if (wasHidden) this.popScrollY = window.scrollY;
    this.pop.hidden = false;
    this.placePop();
    if (wasHidden) {
      this.pop.classList.remove('is-in');
      void this.pop.offsetWidth;
      this.pop.classList.add('is-in');
    }
  };

  // Phones: show the card after a tap. It stays until the shopper touches anything else on the page.
  SizeGuide.prototype.flashPop = function (btn) {
    this.popAbove = true;           // tap card opens above the sizes so Add to cart stays visible
    this.showPop(btn);
  };

  SizeGuide.prototype.hidePop = function () {
    if (!this.pop) return;
    this.popAbove = false;
    this.pop.hidden = true;
    this.pop.classList.remove('is-in');
    if (this.popBtn) {
      this.popBtn.classList.remove('is-peek');
      this.popBtn.removeAttribute('aria-describedby');
    }
    this.popBtn = null;
    this.popFor = null;
  };

  // Fill the popover for this.popFor. Returns false when there's nothing to show.
  SizeGuide.prototype.renderPop = function () {
    var size = this.popFor, pop = this.pop;
    if (!size) return false;
    var u = this.unit;

    if (size === '__custom') {
      pop.innerHTML =
        '<div class="sg-pop-head"><p class="sg-pop-title">Custom size</p></div>' +
        '<p class="sg-pop-text">Made to your measurements. Send them to us — nothing to pay until we confirm.</p>';
      return true;
    }

    var G = this.data.general;
    var row = null;
    if (G && G.sizes) for (var i = 0; i < G.sizes.length; i++) if (G.sizes[i].size === size) { row = G.sizes[i]; break; }
    var s = this.stock(size);
    var picked = this.pickedSize() === size && s.st !== 'out';
    var badge = s.st === 'out' ? '<span class="sg-pop-badge sg-pop-badge--out">' + esc(s.label) + '</span>'
      : picked ? '<span class="sg-pop-badge sg-pop-badge--ok">Selected</span>' : '';

    if (!row) {
      if (!badge) return false;
      pop.innerHTML = '<div class="sg-pop-head"><p class="sg-pop-title">Size ' + esc(size) + '</p>' + badge + '</div>';
      return true;
    }

    var gu = G.unit || 'in';
    var items = chartKeys(G).filter(function (k) { return row[k] != null; }).map(function (k) {
      return '<li>' +
        '<span class="sg-pop-name">' + esc(keyLabel(k)) + '</span>' +
        '<span class="sg-pop-val">' + esc(fmt(row[k], gu, u)) + '<span class="sg-pop-u"> ' + u + '</span></span></li>';
    }).join('');

    pop.innerHTML =
      '<div class="sg-pop-head"><p class="sg-pop-title">Size ' + esc(size) + '</p>' + badge + '</div>' +
      '<p class="sg-pop-sub">Body measurements · ' + (u === 'cm' ? 'cm' : 'inches') + '</p>' +
      '<ul class="sg-pop-list">' + items + '</ul>';
    return true;
  };

  // Under the hovered size, centred on it but kept inside the picker; the arrow points at the size
  SizeGuide.prototype.placePop = function () {
    var btn = this.popBtn, pop = this.pop;
    if (!btn || pop.hidden) return;
    var box = this.picker.getBoundingClientRect();
    var r = btn.getBoundingClientRect();
    var w = pop.offsetWidth;
    var room = Math.max(box.width, w);
    var centre = r.left - box.left + r.width / 2;
    var left = Math.min(Math.max(centre - w / 2, 0), room - w);
    pop.style.left = left + 'px';
    // Above the sizes after a tap (falls back to below when there's no room on screen), below on hover
    var h = pop.offsetHeight;
    var above = !!this.popAbove && r.top - h - 12 >= 0;
    pop.classList.toggle('sg-pop--above', above);
    pop.style.top = (above ? r.top - box.top - h - 10 : r.bottom - box.top + 10) + 'px';
    pop.style.setProperty('--sg-arrow', Math.min(Math.max(centre - left, 16), w - 16) + 'px');
  };

  /* ---------- boot ---------- */

  function init(scope) {
    qsa(scope || document, '[data-size-guide]').forEach(function (el) {
      if (el.__sizeGuide) return;
      try { el.__sizeGuide = new SizeGuide(el); }
      catch (e) { console.error('[size-guide]', e); }
    });
  }

  document.addEventListener('click', function (e) {
    var t = e.target.closest && e.target.closest('[data-size-guide-open]');
    if (!t) return;
    var el = document.querySelector('[data-size-guide]');
    if (el && el.__sizeGuide) {
      e.preventDefault();
      el.__sizeGuide.open(t.getAttribute('data-size-guide-open') || undefined);
    }
  });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else init();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });

  window.SizeGuide = { init: init };
})();
